import { useState } from "react";
import Logout from "../accounts/Logout";
import './Header.css';

export default function Header() {
  const [modal, setModal] = useState(false);

  return (
    <>
      <div className="leetheader">
        <div>
        <strong>LeetClock</strong>
          <button
            className=""
            onClick={() => {
              window.location.href = "/reminder";
            }}
          >
            Reminder
          </button>
          <button
            className=""
            onClick={() => {
              window.location.href = "/todo";
            }}
          >
            Tasks
          </button>
          <button className="logout-button" onClick={() => setModal(true)}>
            Log Out
          </button>
          <Logout modal={modal} setModal={setModal} />
        </div>
      </div>
    </>
  );
}
